// @flow
import React from 'react';
import styled from 'styled-components';
import ReactModal from 'react-modal';

import { colors, modalStyles } from '../../shared/styles';

const StyledDeletePropertyModal = styled(ReactModal)`
    width: 400px;
    margin: 40px auto 0 auto;
    background: ${colors.white};
    border-radius: 4px;

    & .title {
        padding: 10px 20px;
        border-bottom: 1px solid ${colors.offWhite};
    }

    & .title h3 {
        margin: 0;
    }

    & .actions {
        text-align: right;
        padding: 10px;
        border-top: 1px solid ${colors.offWhite};
    }

    & .actions button {
        padding: 5px 10px;
        border: 0;
        border-radius: 4px;
        margin-left: 10px;
        font-size: 14px;
    }

    & .actions button[disabled] {
        opacity: 0.5;
    }

    & .actions .primary {
        background: ${colors.orange.default};
        color: ${colors.white};
    }

    & .actions .secondary {
        background: ${colors.offWhite};
        color: ${colors.grey.default};
    }

    & .content {
        padding: 10px 20px;
    }

    & .content input {
        width: 100%;
        box-sizing: border-box;
        padding: 6px 10px;
        font-size: 14px;
        border-radius: 4px;
        border: solid 1px ${colors.offWhite};
    }
`;

const DeletePropertyModal = (props: any) => {
    const {
        onCancel,
        onEnteredReference,
        onConfirmDelete,
        isOpen,
        removing,
        propertyReference,
        enteredReference,
    } = props;

    const preventSubmit = removing || propertyReference !== enteredReference;

    return (
        <StyledDeletePropertyModal
            contentLabel="Delete Property Confirmation"
            shouldCloseOnOverlayClick={false}
            closeTimeoutMS={200}
            isOpen={isOpen}
            style={modalStyles}
        >
            <div className="title">
                <h3>Delete Property?</h3>
            </div>

            <div className="content">
                <p>
                    To confirm deletion, please enter the reference number{' '}
                    <b>{propertyReference}</b> below.
                </p>

                <input
                    type="text"
                    disabled={removing}
                    placeholder={`Enter "${propertyReference}"...`}
                    onChange={e => {
                        onEnteredReference(e.target.value);
                    }}
                    value={enteredReference || ''}
                    maxLength="8"
                    autoFocus
                />
            </div>

            <div className="actions">
                <button
                    className="secondary"
                    disabled={removing}
                    onClick={onCancel}
                >
                    Cancel
                </button>
                <button
                    className="primary"
                    disabled={preventSubmit}
                    onClick={onConfirmDelete}
                >
                    {removing ? 'Deleting...' : 'Delete Property'}
                </button>
            </div>
        </StyledDeletePropertyModal>
    );
};

export default DeletePropertyModal;



// WEBPACK FOOTER //
// ./src/components/PropertyForms/DeletePropertyModal.js